import { useState } from 'react'
import { CButton, CButtonGroup, CContainer } from '@coreui/react'
import { useQuery } from '@tanstack/react-query'
import { publicApi, apiErrorMessage } from '../../api/client'
import { EmptyState, ErrorState, LoadingState } from '../../components/common/AsyncState'
import { ResearchCard } from '../../components/public/ResearchCard'

const filters = ['', 'paper', 'thesis', 'model', 'dataset', 'software', 'demonstration'] as const
export function ResearchPage() {
  const [type, setType] = useState<(typeof filters)[number]>('')
  const query = useQuery({
    queryKey: ['public', 'research', type],
    queryFn: () => publicApi.research(type ? { type } : undefined),
  })
  return (
    <>
      <section className="page-hero page-hero--research">
        <CContainer xxl>
          <span className="eyebrow">Research impact</span>
          <h1>Trace shared compute to papers, models, datasets and demonstrations.</h1>
          <p>
            Each output may reference a public project alias and an H100 usage window without exposing
            confidential experiment details.
          </p>
        </CContainer>
      </section>
      <section className="section-space--tight">
        <CContainer xxl>
          <div className="filter-row">
            <strong>Output type</strong>
            <CButtonGroup>
              {filters.map((item) => (
                <CButton
                  key={item || 'all'}
                  color={type === item ? 'primary' : 'light'}
                  onClick={() => setType(item)}
                >
                  {item || 'All'}
                </CButton>
              ))}
            </CButtonGroup>
          </div>
          {query.isLoading && <LoadingState />}
          {query.isError && <ErrorState message={apiErrorMessage(query.error)} />}
          {query.data &&
            (query.data.length ? (
              <div className="research-grid research-grid--light">
                {query.data.map((item) => (
                  <ResearchCard key={item._id} item={item} />
                ))}
              </div>
            ) : (
              <EmptyState title="No matching outputs" description="Try a different output category." />
            ))}
        </CContainer>
      </section>
    </>
  )
}
